import api from '@a/config';

const path = 'v1/messmittel/gruppe';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
